import { createClient } from '@supabase/supabase-js';

// Trim to avoid stray whitespace/newlines from env that break websocket URLs
const supabaseUrl = (process.env.REACT_APP_SUPABASE_URL || '').trim();
const supabaseAnonKey = (process.env.REACT_APP_SUPABASE_ANON_KEY || '').trim();

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase configuration. Please set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY');
}

// Custom storage that works in iframe contexts
const customStorage = {
  getItem: (key) => {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      console.error('Storage getItem error:', e);
      return null;
    }
  },
  setItem: (key, value) => {
    try {
      localStorage.setItem(key, value);
      // Also set a timestamp for debugging
      localStorage.setItem(`${key}-timestamp`, new Date().toISOString());
    } catch (e) {
      console.error('Storage setItem error:', e);
    }
  },
  removeItem: (key) => {
    try {
      localStorage.removeItem(key);
      localStorage.removeItem(`${key}-timestamp`);
    } catch (e) {
      console.error('Storage removeItem error:', e);
    }
  }
};

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // Use custom storage for better debugging
    storage: customStorage,
    storageKey: 'sb-auth-token',
    // Persist sessions across page reloads and navigation
    persistSession: true,
    // Automatically refresh expired sessions
    autoRefreshToken: true,
    // Detect session from URL (for email confirmations, password reset, etc.)
    detectSessionInUrl: true,
    // Flow type for better session handling
    flowType: 'pkce',
    // Debug mode for development
    debug: process.env.NODE_ENV === 'development'
  },
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  },
  // Global options
  global: {
    headers: {
      'x-vfr-client': 'admin-panel'
    }
  }
});

// Make supabase globally available for easier access in some components
if (typeof window !== 'undefined') {
  window.supabase = supabase;
}

